<template lang="pug">
    .site-footer
        .footer-wrapper
            .copyright-row
                .copyright © Volkswagen 2020
</template>
<script>
export default {
  name: 'SiteFooter',
  data() {
    return {}
  },

  mounted() {

  }
}
</script>